export const CUSTOMIZATIONS = {
    CUSTOMIZE_BUTTON: "customize-button",
    CUSTOMIZE_MODAL: "customize-modal",
    CUSTOMIZE_MODAL_TITLE: "customize-modal-title",
    CLOSE_CUSTOMIZE_MODAL_BUTTON: "close-customizations-modal-button",
    CUSTOMIZATION_MODAL_ATTRIBUTE: "customization-modal-attribute",
    CUSTOMIZATION_MODAL_ATTRIBUTE_WRAPPER: "customization-modal-attribute-wrapper",
    SELECTED_ATTRIBUTE_TITLE: "selected-attribute-title",
    SELECTED_ATTRIBUTE_IMAGE: "selected-attribute-image",
    CUSTOMIZATION_MODAL_COLOR_ATTRIBUTE_WRAPPER: "customization-modal-color-attribute-wrapper",
    CUSTOMIZATION_MODAL_COLOR_VIEW: "customization-modal-color-view",
    COLOR_ATTRIBUTE_COLOR_PICKER: "color-attribute-color-picker",
    COLOR_SWATCHES: "color-swatches",
    COLOR_SWATCH_ITEM: "color-swatch-item",
    COLOR_SWATCHES_LABEL: "color-swatch-label",
    TRANSPARENT_COLOR_VIEW: "transparent-color-view",
    CUSTOMIZE_MODAL_SAVE_BTN: "customize-modal-save-button",
    CUSTOMIZE_MODAL_CANCEL_BTN: "customize-modal-close-button",
    PRINTED_IMAGE_UPLOADER: "printed-image-uploader",
    PRINTED_IMAGE_FILE_TYPES: "printed-image-file-types",
    UPLOAD_IMAGE_PREVIEW: "upload-image-preview",
    UPLOAD_IMAGE_PREVIEW_NAME: "upload-image-preview-name",
    UPLOAD_IMAGE_DELETE_BUTTON: "upload-image-delete-button",
    UPLOAD_IMAGE_CONTAINER: "upload-image-container",
    UPLOAD_IMAGE_EXISTING: "upload-image-existing",
    EXISTING_IMAGE_LIST_CONTAINER: "existing-image-list-container",
    UPLOAD_EXPAND_UPLOADER: "upload-expand-uploader",
    UPLOAD_FILE_SPEC_ERROR: "upload-file-spec-error",
    PRINTED_IMAGE_REQUIRED_ERROR: "printed-image-required-error",
    EXISTING_IMAGE_LIST_PAGINATION_NEXT: "existing-image-list-pagination-next",
    EXISTING_IMAGE_LIST_PAGINATION_PREV: "existing-image-list-pagination-prev",
    POPOVER_IMAGE: "popover-image",
    POPOVER_IMAGE_NAME: "popover-image-name",
    ERROR_ALERT: "error-alert",
    CHILD_ATTRIBUTES_CONTAINER: "child-attributes-container",
    CHILD_ATTRIBUTE: "child-attribute",
    TEXT_CHILD_ATTRIBUTE: "text-child-attribute",
    PRINT_TYPE_SELECT: "print-type-select",
    PRINT_TYPE_OPTION: "print-type-option",
    PRINT_TYPE_VIEW: "print-type-view",
    EXPAND_IMAGE_SEARCH: "expand-image-search",
    IMAGE_SEARCH: "image-search",
    IMAGE_EXISTING_CONTAINER: "image-existing-container",
    IMAGES_ERROR: "images-error",
    IMAGE_LIST_SPINNER: "image-list-spinner",
    CUSTOMIZATIONS_2D_OVERLAY: "customization-2d-overlay",
    CUSTOMIZATIONS_2D_BACKGROUND: "customization-2d-background",
    CUSTOMIZATIONS_2D_BACKGROUND_CONTAINER: "customization-2d-background-container",
    TABS_CONTAINER: "customization-images-tabs-container",
    EXISTING_IMAGE_BUYER_TAB: "customization-images-buyer-tab",
    EXISTING_IMAGE_BRAND_TAB: "customization-images-brand-tab",
    ATTRIBUTES_DROPDOWN_NOTIFICATION: "customization-attributes-dropdown-notification",
    ATTRIBUTES_DROPDOWN: "customization-attributes-dropdown",
    ATTRIBUTES_DROPDOWN_ITEM: "customization-attributes-dropdown-item",
    ATTRIBUTES_DROPDOWN_ITEM_CHECKBOX: "customization-attributes-dropdown-item-checkbox",
    CUSTOMIZATION_MODAL_ATTRIBUTE_PICKERS_LIST: "customization-modal-attribute-pickers-list",
    ATTRIBUTE_DETAILS_CONTAINER: "customization-attribute-details-container",
    PRODUCT_DESCRIPTION: "customization-product-description",
    DELETE_ATTRIBUTE_BUTTON: "customization-delete-attribute-button",
    ATTRIBUTE_DETAILS_COLLAPSE: "customization-attribute-details-collapse",
    POPOVER_IMAGE_ATTRIBUTE: "customization-image-attribute",
    CUSTOMIZE_MODAL_BULK_CUSTOMIZATIONS_BTN: "customization-modal-bulk-customizations-button",
    PRODUCT_LIST_TABLE: "product-list-table",
    PRODUCT_LIST_ROW: "product-list-row",
    PRODUCT_LIST_ROW_CHECKBOX: "product-list-row-checkbox",
    PRODUCT_LIST_ROW_CELL: "product-list-row-cell",
    PRODUCT_LIST_ROW_HEADER_CELL: "product-list-row-cell",
    BULK_CUSTOMIZATIONS_MODAL: "bulk-customization-modal",
    ADD_BULK_CUSTOMIZATIONS_BTN: "add-bulk-customization-button",
    APPLY_BULK_CUSTOMIZATIONS_BTN: "apply-bulk-customization-button",
    CANCEL_BULK_CUSTOMIZATIONS_BTN: "cancel-bulk-customization-button",
    PRODUCT_CUSTOMIZATIONS_CONTAINER: "product-customizations-container",
    PRODUCT_CUSTOMIZATION_TITLE: "product-customization-title",
    PRODUCT_CUSTOMIZATION_TITLE_LABEL: "product-customization-title-label",
    PRODUCT_CUSTOMIZATION: "product-customization",
    PRODUCT_CUSTOMIZATION_LABEL: "product-customization-label",
    PRODUCT_CUSTOMIZATION_VALUE: "product-customization-value",
    CUSTOMIZATION_PRINT_TYPE: "customization-print-type",
    CUSTOMIZATION_PRINT_TYPE_LABEL: "customization-print-type-label",
    CUSTOMIZATION_PRINT_TYPE_VALUE: "customization-print-type-value",
    CUSTOMIZATION_SHOW_LOGO_BTN: "customization-show-logo-btn",
    CUSTOMIZATION_LOGO_IMAGE: "customization-logo-image",
    BULK_CUSTOMIZATION_PRODUCT_SEARCH: "bulk-customizations-product-search",
    CUSTOMIZATION_PRINTED_TEXT_TEXT: "customization-printed-text-text",
    CUSTOMIZATION_PRINTED_TEXT_FONT: "customization-printed-text-font",
    CUSTOMIZATION_PRINTED_TEXT_FONT_SIZE: "customization-printed-text-font-size",
    CUSTOMIZATION_COLOR: "customization-color",
    EDIT_CUSTOMIZATION: "edit-customization",
    TEXT_ATTRIBUTE_ERROR: "customization-text-attribute-error",
    LENGTH_COUNTER: "customization-text-length-counter",
    BRAND_SETTINGS_ADD_PRINT_TYPE_BTN: "brand-settings-add-print-type-button",
    BRAND_SETTINGS_BODY_CONTAINER: "brand-settings-body-container",
    BRAND_SETTINGS_PRINT_TYPES_SAVE_BTN: "brand-settings-print-types-save-btn",
    BRAND_SETTINGS_REMOVE_PRINT_TYPE_BTN: "brand-settings-remove-print-types-btn",
    BRAND_SETTINGS_PRINT_TYPE_INPUT: "brand-settings-print-type-input",
    BRAND_SETTINGS_ADD_IMAGE_TYPE_BTN: "brand-settings-add-image-type-button",
    BRAND_SETTINGS_IMAGE_TYPE: "brand-settings-image-type",
    BRAND_SETTINGS_ADD_IMAGE_TYPE_DIALOG_CANCEL_BTN: "brand-settings-add-image-type-dialog-cancel-button",
    BRAND_SETTINGS_ADD_IMAGE_TYPE_DIALOG_ADD_BTN: "brand-settings-add-image-type-dialog-add-button",
    REQUIRED_ATTRIBUTE_ERROR: "customization-modal-required-error",
    PENDING_LOGO_IMAGE_TAB: "pending-logo-image-tab",
    APPROVED_LOGO_IMAGE_TAB: "approved-logo-image-tab",
    REJECTED_LOGO_IMAGE_TAB: "rejected-logo-image-tab",
    LOGO_LIST_ROW_HEADER_CELL: "logo-list-row-header-cell",
    LOGO_LIST_ROW_CELL: "logo-list-row-cell",
    LOGO_LIST_ROW: "logo-list-row",
    IMAGE_LOGO: "image-logo",
    LOGO_SEARCH: "logo-search",
    LOGO_CELL_CHECKBOX: "logo-cell-checkbox",
    LOGO_CELL_LOGO: "logo-cell-logo",
    LOGO_CELL_FILE_NAME: "logo-cell-file-name",
    LOGO_CELL_CUSTOMER: "logo-cell-customer",
    LOGO_CELL_STATUS: "logo-cell-status",
    LOGO_CELL_TAG: "logo-cell-tag",
    LOGO_SELECT_ALL_CHECKBOX: "logo-select-all-checkbox",
    CLOSE_LOGO_ACTIONS_PANEL: "close-logo-action-panel",
    TAG_MODAL_NAME_INPUT: "tag-modal-name-input",
    TAG_MODAL_COMPANY_INPUT: "tag-modal-company-input",
    TAG_MODAL_TAG_INPUT: "tag-modal-tag-input",
    LOGO_PRINT_TYPES_DROPDOWN: "logo-print-types-dropdown",
    LOGO_PRINT_TYPES_DROPDOWN_ITEM: "logo-print-types-dropdown-item",
    LOGO_PRINT_TYPES_DROPDOWN_ITEM_CHECKBOX: "logo-print-types-dropdown-item-checkbox",
    IMAGE_FILENAME: "image-filename",
    APPROVE_IMAGE: "approve-image",
    REJECT_IMAGE: "reject-image",
    DOWNLOAD_IMAGE: "download-image",
    EDIT_IMAGE: "edit-image",
    CANCEL_EDIT_IMAGE_TAG_BUTTON: "cancel-edit-image-tag-button",
    SAVE_IMAGE_TAG_BUTTON: "save-image-tag-button",
    SAVE_AND_APPROVE_IMAGE_TAG_BUTTON: "save-and-approve-image-tag-button",
    TAG_MODAL_BOOLEAN_CHECKBOX: "tag-modal-boolean-checkbox",
    PRINT_TYPES_FILTER_OPEN: "print-types-filter-open",
    PRINT_TYPES_FILTER_MENU: "print-types-filter-menu",
    PRINT_TYPES_FILTER_ITEM: "print-types-filter-item",
    PRINT_TYPES_FILTER_SEARCH: "company-filter-search",
    COMPANY_FILTER_OPEN: "company-filter-open",
    COMPANY_FILTER_MENU: "company-filter-menu",
    COMPANY_FILTER_ITEM: "company-filter-item",
    COMPANY_FILTER_SEARCH: "company-filter-search",
    UPLOAD_PROOF_BTN: "upload-proof",
    REUPLOAD_PROOF_BTN: "reupload-proof",
    DOWNLOAD_PROOF_BTN: "download-proof",
    DELETE_PROOF_BTN: "delete-proof",
    UPLOAD_PROOF_MODAL: "upload-proof-modal",
    UPLOAD_PROOF_MODAL_HEADER: "upload-proof-modal-header",
    UPLOAD_PROOF_MODAL_UPLOADER: "upload-proof-modal-uploader",
    UPLOAD_PROOF_MODAL_CANCEL_BUTTON: "upload-proof-modal-cancel-button",
    UPLOAD_PROOF_MODAL_SPECIFICATIONS: "upload-proof-modal-specifications",
    DELETE_PROOF_MODAL: "delete-proof-modal",
    DELETE_PROOF_MODAL_HEADER: "delete-proof-modal-header",
    DELETE_PROOF_MODAL_CANCEL_BUTTON: "delete-proof-modal-cancel-btn",
    DELETE_PROOF_MODAL_DELETE_BUTTON: "delete-proof-modal-delete-btn",
    EDIT_CUSTOMIZATION_PROOF_MODAL: "edit-customization-proof-modal",
    EDIT_CUSTOMIZATION_PROOF_MODAL_HEADER: "edit-customization-proof-modal-header",
    EDIT_CUSTOMIZATION_PROOF_MODAL_CANCEL_BUTTON: "edit-customization-proof-modal-cancel-btn",
    EDIT_CUSTOMIZATION_PROOF_MODAL_EDIT_BUTTON: "edit-customization-proof-modal-edit-btn",
} as const;
